module.exports = __webpack_public_path__ + "img/header-weddingRingsGold.41b3ded.jpg";